import React from "react";
import "../Page/css/Projects.scss";

function Projects() {
  return (
    <div id="projects" className="ProjectsTop">
      Projects Page
    </div>
  );
}

export default Projects;
